import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getWopi360Target } from '../../ducks/wopi360-target'
import { editWopi360Target } from '../../ducks/wopi360-targets-admin'
import { getUnits } from '../../ducks/unit-admin'

import Wopi360TargetEdit from '../Wopi360TargetEdit'
import Loading from '../Loading'

class Wopi360TargetEditContainer extends Component {
  componentDidMount() {
    this.props.getWopi360Target(this.props.params.uuid)
    this.props.getUnits(this.props.currentOrganisationId)
  }

  render() {
    const {
      wopi360Target,
      wopi360TargetIsLoading,
      currentOrganisationId,
      currentLanguage,
      editWopi360Target,
      units
    } = this.props

    return (
      <Loading inline={true} isReady={!wopi360TargetIsLoading && wopi360Target}>
        {wopi360Target && (
          <Wopi360TargetEdit
            wopi360Target={wopi360Target}
            currentOrganisationId={currentOrganisationId}
            currentLanguage={currentLanguage}
            onEdit={editWopi360Target}
            units={units}
          />
        )}
      </Loading>
    )
  }
}

export default connect(
  state => ({
    currentLanguage: state.account.get('currentLanguage'),
    currentAccount: state.account.get('currentAccount'),
    wopi360Target: state.wopi360Target.target.get('target'),
    wopi360TargetIsLoading: state.wopi360Target.target.get('isLoading'),
    units: state.unitAdmin.get('units')
  }),
  {
    editWopi360Target,
    getWopi360Target,
    getUnits
  }
)(Wopi360TargetEditContainer)



// WEBPACK FOOTER //
// ./src/components/smart/Wopi360TargetEditContainer.js